/* unplugin-vue-components disabled */import { render } from "./teacherAndCourse.vue?vue&type=template&id=f987ff1e&scoped=true"
import script from "./teacherAndCourse.vue?vue&type=script&lang=js"
export * from "./teacherAndCourse.vue?vue&type=script&lang=js"

import "./teacherAndCourse.vue?vue&type=style&index=0&id=f987ff1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f987ff1e"]])

export default __exports__